import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { MUIThemeColors } from 'src/mui-theme'
import { Flex } from 'src/styles/flexComponent'
import { getThemeColor } from 'src/utils'

type Props = {
  /** Eyebrow-style section title */
  title: string
  /** Buttons rendered right-aligned in the header */
  actions?: React.ReactNode
  children: React.ReactNode
  /** Body padding in px (default 16) */
  bodyPadding?: number
  /** Removes body padding entirely (for tables that manage their own padding) */
  noBodyPadding?: boolean
  /** Stretch the card to fill its container height (for equal-height columns) */
  fullHeight?: boolean
}

export const DeviationSectionCard: React.FC<Props> = ({
  title,
  actions,
  children,
  bodyPadding = 16,
  noBodyPadding = false,
  fullHeight = false,
}) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: getThemeColor(theme, MUIThemeColors.white),
        borderRadius: '8px',
        border: '1px solid #E6E8EA',
        height: fullHeight ? '100%' : undefined,
      }}
    >
      <Flex.Row
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 16px',
          borderBottom: '1px solid #E6E8EA',
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.6px',
            color: getThemeColor(theme, MUIThemeColors.secondaryMain),
          }}
        >
          {title}
        </Typography>
        {actions && (
          <Flex.Row gap={1} sx={{ alignItems: 'center' }}>
            {actions}
          </Flex.Row>
        )}
      </Flex.Row>
      <Box sx={{ padding: noBodyPadding ? 0 : `${bodyPadding}px` }}>{children}</Box>
    </Box>
  )
}
